import * as xlsx from "xlsx";
import * as FileSaver from "file-saver";

const parseNumber = (value: any): number | null => {
  if (value === null || value === undefined || value === "") return null;

  const normalized = String(value).replace(",", ".");
  const number = Number(normalized);

  return Number.isNaN(number) ? null : number;
};

const formatConteudoLiquido = (item: any): string => {
  const valor = parseNumber(item.CONT_LIQUIDO);

  const unidade = (
    item.UNIDADE_MEDIDA ||
    item.UNIDADE_MEDIDA_CONTEUDO ||
    item.UNIDADE ||
    item.MEDIDA ||
    ""
  ).toString().trim();

  if (valor === null) return "";

  const unidadeFinal = unidade || "L";
  const unidadeUpper = unidadeFinal.toUpperCase();

  if (
    unidadeUpper === "L" ||
    unidadeUpper === "LT" ||
    unidadeUpper === "LITRO" ||
    unidadeUpper === "LITROS"
  ) {
    const valorEmMl = valor * 1000;
    return `${valorEmMl} ml`;
  }

  if (
    unidadeUpper === "ML" ||
    unidadeUpper === "MILILITRO" ||
    unidadeUpper === "MILILITROS"
  ) {
    return `${valor} ml`;
  }

  return `${valor} ${unidadeFinal}`;
};

export function exportFileTestSimilaridade(dataPrepared: any[], filetype: string) {
  const rows = (Array.isArray(dataPrepared) ? dataPrepared : []).map((item: any) => {
    const similaridadeFormatada =
      item.SIM_COS != null
        ? `${(Number(item.SIM_COS) * 100).toFixed(2)}%`
        : "";

    return {
      "GTIN": item.GTIN || "",
      "Descrição": item.DESCRICAO || "",
      "Marca": item.MARCA || "",
      "Conteúdo Líquido": formatConteudoLiquido(item),
      "Similaridade": similaridadeFormatada,
      "Tipo GTIN": item.TIPO_GTIN || ""
    };
  });

  const ws = xlsx.utils.json_to_sheet(rows);

  const wb = {
    Sheets: { data: ws },
    SheetNames: ["data"]
  };

  const excelBuffer = xlsx.write(wb, {
    bookType: filetype === "xls" ? "xls" : "csv",
    type: "array"
  });

  const data = new Blob([excelBuffer]);

  FileSaver.saveAs(data, `resultado_similaridade.${filetype}`);
}